module.exports = "https://web-assets.ifttt.com/packs/media/home/home_header_services-6ff25804.svg";